// extracted by mini-css-extract-plugin
module.exports = {"notfound":"notfound_notfound__13hNL","logoWrapper":"notfound_logoWrapper__2SjCZ"};